var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c("seminar-entry-message-register-form", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isSendable,
            expression: "!isSendable",
          },
        ],
        ref: "seminarEntryMessageRegisterForm",
        attrs: { "entry-ids": _vm.entryIds },
        on: { filledOut: _vm.onFilledOut },
        model: {
          value: _vm.message,
          callback: function ($$v) {
            _vm.message = $$v
          },
          expression: "message",
        },
      }),
      _vm._v(" "),
      _c("seminar-entry-message-register-confirm", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isSendable,
            expression: "isSendable",
          },
        ],
        attrs: { message: _vm.message },
        on: {
          back: function ($event) {
            _vm.isSendable = false
          },
          submitted: _vm.onRegistered,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }